import initialState from '../../initialstate';
import * as types from '../../../actions/actiontypes';

export default function modalOpenUnsavedUserDataReducer(state = initialState.unsavedData, action) {
	switch (action.type) {
		case types.SET_UNSAVED_DATA: {
            let unsavedRegions = {...state}
            if(action.value && !state.hasOwnProperty(action.region)) {
                unsavedRegions[action.region] = action.value
            } 
            if(!action.value && state.hasOwnProperty(action.region)) {
                delete unsavedRegions[action.region]
            }
			return unsavedRegions;
		}
        case types.CLEAR_UNSAVED_DATA_STATE: {
            return {}
        }
		default:
			return state;
	}
}
